import { AutoFocus } from 'primeng/autofocus'

let patched = false

/**
 * #3264 A11 — PrimeNG 21 marks every p-button and p-select `autofocus="true"`.
 *
 * Its AutoFocus directive (`[pAutoFocus]`) removes the DOM attribute only for an input
 * of exactly `false` and sets it for anything else. p-button binds
 * `autofocus || buttonProps?.autofocus` and p-select binds `autofocus`, both `undefined`
 * unless a page asks for autofocus. So the attribute landed on nearly every control, and
 * the browser autofocused the first one inserted after load: a deep link such as
 * /admin/customers/:id?tab=deals opened with focus (and its ring) on "Assign deals".
 *
 * An unset input means "no autofocus". Normalising it to `false` before the directive's
 * hook runs keeps a page that does ask (`[autofocus]="true"`) working unchanged. Remove
 * this once PrimeNG treats an unset input as false.
 */
export function patchPrimeNgAutoFocus(): void {
  if (patched) return
  patched = true
  const proto = AutoFocus.prototype as unknown as { autofocus: unknown; onAfterContentChecked(): void }
  const original = proto.onAfterContentChecked
  proto.onAfterContentChecked = function (this: { autofocus: unknown }) {
    if (this.autofocus == null) this.autofocus = false
    original.call(this)
  }
}
